import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Typography, Paper, Grid, Card } from '@mui/material';
import { useStore } from '../stores';
import DashboardLayout from '../components/layout/DashboardLayout/DashboardLayout';
import DriverMap from '../components/map/DriverMap';
import DriversSelector from '../components/selector/DriversSelector';
import Calendar from '../components/common/Calendar';
import StatusTimeline from '../components/common/StatusTimelineItem';

const History: React.FC = () => {
    const { authStore } = useStore();

    const MOCK_STATUSES = [
        {
            id: 1,
            status: 'Disponible',
            time: '10:00 am',
            description: 'Empecé a trabajar',
            timestamp: new Date('2025-07-25T10:00:00')
        },
        {
            id: 2,
            status: 'En ruta',
            time: '11:00 am',
            description: 'Carrera con destino a la Previsora',
            timestamp: new Date('2025-07-25T11:00:00')
        },
        {
            id: 3,
            status: 'Descanso',
            time: '12:00 pm',
            description: 'Tomaré un descanso para almorzar',
            timestamp: new Date('2025-07-25T12:00:00')
        }
    ];

    const MORE_STATUSES = [
        {
            id: 4,
            status: 'En ruta',
            time: '1:30 pm',
            description: 'Recogida en el centro comercial',
            timestamp: new Date('2025-07-25T13:30:00')
        },
        {
            id: 5,
            status: 'Disponible',
            time: '2:45 pm',
            description: 'Completé la entrega',
            timestamp: new Date('2025-07-25T14:45:00')
        },
        {
            id: 6,
            status: 'Descanso',
            time: '4:00 pm',
            description: 'Pausa para café',
            timestamp: new Date('2025-07-25T16:00:00')
        },
        {
            id: 7,
            status: 'En ruta',
            time: '4:30 pm',
            description: 'Entrega urgente',
            timestamp: new Date('2025-07-25T16:30:00')
        },
        {
            id: 8,
            status: 'Disponible',
            time: '5:45 pm',
            description: 'Esperando nuevas asignaciones',
            timestamp: new Date('2025-07-25T17:45:00')
        }
    ];

    const [items, setItems] = useState(MOCK_STATUSES);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);

    const loadMoreItems = () => {
        if (page > 1) return;

        setLoading(true);

        setTimeout(() => {
            setItems(prevItems => [...prevItems, ...MORE_STATUSES]);
            setPage(2);
            setLoading(false);
        }, 1500);
    };

    return (
        <DashboardLayout>
            <Box>
                <Typography variant="h4" sx={{ mb: 1 }}>
                    Historico
                </Typography>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 6, lg: 7, xl: 7 }}>
                        <DriverMap
                            height="100%"
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6, lg: 5, xl: 5 }}>
                        <DriversSelector />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6, lg: 7, xl: 7 }}>
                        <Calendar />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6, lg: 5, xl: 5 }}>
                        <StatusTimeline
                            initialItems={items}
                            loading={loading}
                            onLoadMore={loadMoreItems}
                            maxHeight={500}
                        />
                    </Grid>
                </Grid>
            </Box>
        </DashboardLayout >
    );
};

export default observer(History);